// 地址区域
export var ZONE = {
    CHN: 'CHN',
    CN: 'CN',
    HK: 'HK',
    MO: 'MO',
    TW: 'TW',
    EN: 'EN' // 英文
};
// 寄件类型
export var SEND_TYPE = {
    CN_HK_MO_TW: 'CN_HK_MO_TW',
    CN_CHN: 'CN_CHN',
    CN_CN: 'CN_CN',
    CN_CN_NIKE: 'CN_CN_NIKE',
    CN_HK: 'CN_HK',
    CN_MO: 'CN_MO',
    CN_TW: 'CN_TW',
    CN_EN: 'CN_EN',
    CHN_EN: 'CHN_EN',
    HK_CN: 'HK_CN',
    HK_HK: 'HK_HK',
    HK_MO: 'HK_MO',
    HK_TW: 'HK_TW',
    HK_CHN: 'HK_CHN',
    MO_CN: 'MO_CN',
    MO_HK: 'MO_HK',
    MO_CHN: 'MO_CHN',
    TW_CN: 'TW_CN',
    TW_TW: 'TW_TW',
    TW_HK: 'TW_HK',
    TW_CHN: 'TW_CHN',
    EN_CN: 'EN_CN',
    EN_HK: 'EN_HK',
    FSS: 'FSS',
    IBU_US: 'IBU_US',
    TE: 'TE',
    HK_MO_TW: 'HK_MO_TW',
    HK_MO_TC: 'HK_MO_TC' // 港澳
};
// 港澳台locationCode
export var HK_MO_TW_MAP = new Map([
    ['852', 'HK'],
    ['853', 'MAC'],
    ['886', 'TW']
]);
// 特殊地区locationCodde
export var LOCATION_CODE_MAP = {
    MAINLAND: '86',
    HK: '852',
    MAC: '853',
    TW: '886'
};
/** 寄件流向 */
export var FLOW_DISTRICT_MAP = {
    /** 大陆 */
    CHN: 0,
    /** 港澳台 */
    HK_MO_TW: 1,
    /** 国际 */
    IBU: 2
};
/**
 * countrycode
 * HK 香港
 * MAC 澳门
 * TW 台湾
 * MAINLAND 大陆
 */
export var COUNTRY_CODE = {
    HK: 'A000810000',
    MAC: 'A000820000',
    TW: 'A000710000',
    MAINLAND: 'A000086000'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/business-constants/dist/esm/address.js
// module id = null
// module chunks = 